import { Component, ViewEncapsulation } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { UntypedFormGroup } from '@angular/forms';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../formly/ga-formly.service';

export interface ISelectHeaderParams extends IHeaderParams {
  modelValue:any;
  formatting:Function | string;
  items:any[];
  trackBy:string;

  onValueChange(newValue:any, oldValue:any, params:ISelectHeaderParams):void;
}

@Component({
  selector: 'ag-select-header',
  template: `
    <div class="row">
      <div class="col-sm-12">
        <div class="form-horizontal">
          <formly [form]="form" [fields]="fields" [model]="model" [noValidate]="true"></formly>
        </div>
      </div>
    </div>
  `,
  styles: [
    'ag-select-header { width: 100%; }'
  ],
  encapsulation: ViewEncapsulation.None
})
export class AgSelectHeaderComponent implements IHeaderAngularComp {
  private params:ISelectHeaderParams;

  public form:UntypedFormGroup = new UntypedFormGroup({});
  public fields:IExtraFieldConfigurationObject[];
  public model:{ value:any } = {
    value: undefined
  };

  constructor(
    private formlyService:GaFormlyService
  ) {
    /**/
  }

  public agInit(params:ISelectHeaderParams):void {
    this.params = params;

    // set default value
    if (this.params.modelValue && this.params.modelValue[ this.params.trackBy ]) {
      this.model.value = this.params.modelValue;
    }

    // create formly fields
    this.createFields();
  }

  public refresh():boolean {
    return true;
  }

  private createFields():void {
    const valueClass:string = 'col-sm-12';

    this.fields = [
      this.formlyService.aSelect('value')
        .withoutWrapper()
        .withWrapperClass('row')
        .withValueClass(valueClass)
        .withFormat(this.params.formatting)
        .withExtraOptions({
          templateOptions: {
            trackBy: this.params.trackBy
          }
        })
        .onChange((newValue:any, oldValue:any) => this.params.onValueChange(newValue, oldValue, this.params.modelValue))
        .withOptions(this.params.items)
        .build()
    ];
  }
}